module.exports = __webpack_public_path__ + "03_face.d45700e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/03_face.png
// module id = PkJZ
// module chunks = 0